import { Link } from "react-router-dom";

import { useOrders } from "@/hooks";

export const OrderBreadcrumb = (props: {
  orderId: string;
  isOms?: boolean;
}) => {
  const { useGetOrder } = useOrders();
  const { data: order, isPending } = useGetOrder({
    orderId: props.orderId,
  });
  if (isPending) {
    return;
  }
  return (
    <Link to={`/${props.isOms ? "oms/" : ""}orders/${props.orderId}`}>
      {order?.data.name}
    </Link>
  );
};
